export default __webpack_public_path__ + "static/media/the_lovers.fe6722b2.png";